(function ($) {
  'use strict';

  /**
   * Video Pause/Play Controls
   */

  // Get 'Reduced Motion' Preference
  var mql = window.matchMedia('(prefers-reduced-motion: reduce)');
  var is_reduced_motion = mql === true || mql.matches === true;

  var $background_videos = $('.js-background-video');

  $background_videos.each(function () {
    var $this_video = $(this);
    var this_video_el = $this_video.get( 0 );
    var this_video_id = $this_video.attr( 'id' );
    var $this_control = $('.js-video-playback-control[aria-controls="' + this_video_id + '"]');
    var $this_control_label = $this_control.find( '.js-video-playback-control-label' );
    // Translated labels from data attrs
    var label_is_paused = $this_control.data( 'label-is-paused' );
    var label_is_playing = $this_control.data( 'label-is-playing' );

    // Pause by default
    this_video_el.pause();
    $this_control.attr( 'data-is-playing', false );
    $this_control_label.text( label_is_paused );

    // Auto-play video if 'Reduced Motion' is _not_ enabled
    if ( ! is_reduced_motion ) {
      this_video_el.play();
      $this_control.attr( 'data-is-playing', true );
      $this_control_label.text( label_is_playing );
    }

    // Playback Controls
    $this_control.on('click', function () {
      var $this = $(this);
      var is_playing = $this.attr( 'data-is-playing' );

      // Pause Video
      if ( is_playing === 'true' ) {
        this_video_el.pause();
        $this.attr( 'data-is-playing', false );
        $this_control_label.text( label_is_paused );

      // Play Video
      } else if ( is_playing === 'false' ) {
        this_video_el.play();
        $this_control.attr( 'data-is-playing', true );
        $this_control_label.text( label_is_playing );
      }
    });
  });

  // Pause all videos if 'Reduced Motion' preference is updated after init
  $(mql).on('change', function (e) {
    is_reduced_motion = e.originalEvent === true
      || e.originalEvent.matches === true;

    $background_videos.each(function () {
      var $this_video = $(this);
      var this_video_el = $this_video.get( 0 );
      var this_video_id = $this_video.attr( 'id' );
      var $this_control = $('.js-video-playback-control[aria-controls="' + this_video_id + '"]');
      var $this_control_label = $this_control.find( '.js-video-playback-control-label' );
      var label_is_paused = $this_control.data( 'label-is-paused' );

      // Pause video
      if ( is_reduced_motion ) {
        this_video_el.pause();
        $this_control.data( 'aria-pressed', true );
        $this_control_label.text( label_is_paused );
      }
    });
  });

})(jQuery);
